export default "__VITE_ASSET__BhKS$3Oy__"